module.exports = __webpack_public_path__ + "img/hr-tree-02-b-leaves.1c98270d.png";